import React, { useContext } from "react";
import "./styles/dock.css";
import x from "./assets/xlogo.png";
import github from "./assets/githublogo.png";
import linkedin from "./assets/linkedinlogo.png";
import gmaillogo from "./assets/gmaillogo.png";
import codecheflogo from "./assets/codecheflogo.png";
import folder from "./assets/folder.png";
import document from "./assets/document.png"
import { desktopContext } from "./context/desktopContext";

const Dock = () => {


  const cntxt = useContext(desktopContext)


  var icon = ''
  if (cntxt.app === 'Filemanager'){
    icon = <img className="dock-img" src={folder} alt="folder" />
  }else{
    icon = <img className="dock-img" src={document} alt="document" />
  }

  return (
    <div className="center-div">
      <div className="dock">
        <img
          className="dock-img"
          src={x}
          onClick={() => {
            window.open("https://twitter.com/dhruvgupta3377", "_blank");
          }}
          alt="twitter"
        />
        <img
          className="dock-img"
          src={github}
          onClick={() => {
            window.open("https://github.com/dhruvgupta3377", "_blank");
          }}
          alt="github"
        />
        <img
          className="dock-img"
          src={linkedin}
          onClick={() => {
            window.open("https://www.linkedin.com/in/dhruv-gupta-465391227/", "_blank");
          }}
          alt="linkedin"
        />
        <img
          className="dock-img"
          src={gmaillogo}
          onClick={() => {
            navigator.clipboard
              .writeText("dhruvgupta3377@gmail.com")
              .then(alert("copied to clipboard"));
          }}
          alt="gmail"
        />
        {cntxt.windowOpen && icon}
      </div>
    </div>
  );
};

// {/* <img
//   className="dock-img"
//   src={codecheflogo}
//   onClick={() => {
//     window.open("https://www.codechef.com/users/sedlyf96/", "_blank");
//   }}
//   alt="codechef"
// /> */}
export default Dock;
